var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"copyright"},[_c('div',{staticClass:"container"},[_c('center',[_c('center',[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Nasmoco Group")]),_vm._v(" - "+_vm._s(_vm.year)+" © All Rights Reserved")])])],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }